import React from 'react';
import { Pressable, View } from 'react-native';

import { Text } from '@squire/ui';

import { GiftIcon } from '@/components/_icons/GiftIcon';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { GiftCardProps } from './types';

export function GiftCardOption({
  onPress,
  testID = 'gift-card',
  style,
}: GiftCardProps) {
  const { t } = useScreenTranslations('GiftCard');

  const handlePress = () => {
    onPress?.();
  };

  return (
    <Pressable
      onPress={handlePress}
      testID={testID}
      style={style}
      accessibilityRole="button"
      accessibilityLabel={t('title')}
      accessibilityHint={t('subtitle')}
    >
      {({ pressed }) => (
        <View style={[styles.wrapper, pressed && styles.wrapperPressed]}>
          <View style={styles.iconWrapper}>
            <GiftIcon />
          </View>

          <View style={styles.contentWrapper}>
            <Text
              variant="lStrong"
              style={styles.title}
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              {t('title')}
            </Text>

            <Text
              variant="s"
              style={styles.subtitle}
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              {t('subtitle')}
            </Text>
          </View>
        </View>
      )}
    </Pressable>
  );
}
